import { CheckCircle2 } from "lucide-react";

const PILLARS = [
  "Confidence",
  "Discipline",
  "Basketball IQ",
  "Athleticism",
  "Leadership",
  "Elite Skills",
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-[#050505] py-20 md:py-32 border-b border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#60A5FA]">
              [ 01 — About ]
            </div>
            <h2 className="font-display mt-6 text-4xl md:text-5xl lg:text-6xl font-bold uppercase tracking-tight leading-[1.0]">
              Building Athletes
              <br />
              <span className="text-[#2563EB]">The Right Way</span>
            </h2>
            <p className="mt-8 text-[#A1A1AA] text-base md:text-lg leading-relaxed max-w-xl">
              BlueprintHoopz is built on the belief that great players are
              developed, not born. We blend modern player development, elite
              performance training, and a relentless growth mindset into one
              program designed to take athletes to the next level.
            </p>

            <div className="mt-10 grid grid-cols-2 gap-x-6 gap-y-3">
              {PILLARS.map((p) => (
                <div
                  key={p}
                  className="flex items-center gap-2 text-sm text-white/85"
                >
                  <CheckCircle2 size={16} className="text-[#2563EB]" />
                  {p}
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="bg-[#070B14] border border-white/5 p-8 md:p-10">
              <div className="text-[10px] tracking-[0.3em] uppercase text-[#60A5FA] mb-6">
                [ Our Mission ]
              </div>
              <p className="font-display text-2xl md:text-3xl leading-tight tracking-tight text-white">
                Help athletes develop{" "}
                <span className="text-[#60A5FA]">confidence</span>, discipline,
                basketball IQ,{" "}
                <span className="text-[#60A5FA]">athleticism</span>, leadership,
                and elite-level basketball skills.
              </p>

              <div className="mt-10 grid grid-cols-3 divide-x divide-white/5 border-t border-white/5 pt-8">
                <div className="text-center px-2">
                  <div className="font-display text-3xl md:text-4xl font-bold text-[#2563EB]">
                    1:1
                  </div>
                  <div className="mt-1 text-[10px] tracking-[0.25em] uppercase text-white/60">
                    Player Focus
                  </div>
                </div>
                <div className="text-center px-2">
                  <div className="font-display text-3xl md:text-4xl font-bold text-[#2563EB]">
                    5x
                  </div>
                  <div className="mt-1 text-[10px] tracking-[0.25em] uppercase text-white/60">
                    Days / Week
                  </div>
                </div>
                <div className="text-center px-2">
                  <div className="font-display text-3xl md:text-4xl font-bold text-[#2563EB]">
                    All
                  </div>
                  <div className="mt-1 text-[10px] tracking-[0.25em] uppercase text-white/60">
                    Skill Levels
                  </div>
                </div>
              </div>
            </div>

            <div className="absolute -z-10 -inset-6 bg-[#2563EB]/5 blur-2xl" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
